import DynamicForm from "../../../../components/FormElements/DynamicForm";
import * as Yup from 'yup';
import { Col, Row } from "antd";
import logo from '../../../../assets/images/logo.png'
import AuthLayout from "../../../../components/Layout/AuthLayout";
import './style.css'
import Button from "../../../../components/FormElements/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Modal from "../../../../components/Modal";
import { authTypes } from "../../../../config/utils/constants";
import useAuthApi from "../../../../config/hooks/api/auth/useAuthApi";
import { decrementTimer, resetTimer, setAppLoading, setError, setMessage, startTimer, stopTimer } from "../../../../store/common/generalSlice";
import { useDispatch, useSelector } from "react-redux";
import OtpInput from "../../../../components/FormElements/OtpInput";


const Verification = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { verifyOtp, forgotPassword } = useAuthApi()
  const location = useLocation(); // Hook to access the current location

  const [openBusinessActionModal, setOpenBusinessActionModal] = useState(false)
  const [navigationRoute, setNavigationRoute] = useState('')
  const [value, setValue] = useState('')
  // const [showPrompt, setShowPrompt] = useState(false)
  const [requestCompleted, setRequestCompleted] = useState(false)

  const timeLeft = useSelector((state) => state.general.timeLeft);
  const isRunning = useSelector((state) => state.general.isRunning);


  // Block navigating elsewhere when data has been entered into the input
  // let blocker = useBlocker(
  //   ({ currentLocation, nextLocation }) =>
  //     value &&
  //     currentLocation.pathname !== nextLocation.pathname
  // );

  // Define the form configuration
  const form = {
    name: 'otpForm',
    formFields: [
      {
        name: 'otp',
        type: 'custom',
        label: { value: '', style: '', classes: '' },
        placeholder: '',
        width: { md: 24, sm: 24, xs: 24 },
        component: <OtpInput length={4} />,
        classes: '',
        icon: null
      },
    ],
    formValidation: {
      otp: Yup.string()
        .required('OTP is required')
        .matches(/^[0-9]{4}$/, 'OTP must be a 4-digit number')
    },
  }

  
  const handleStart = () => {
    dispatch(startTimer());
  };

  const handleStop = () => {
    dispatch(stopTimer());
  };

  const handleReset = () => {
    dispatch(resetTimer(60)); // Reset to 60 seconds or any other initial value
  };

  const handleOtp = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('tempUser'))
      if (!user || !user.email || (!user.type == 1 && !user.type == 2)){
        dispatch(setError('Something went wrong'))
        return
      } 

      const { email } = user

      dispatch(setAppLoading(true))

      const response = await forgotPassword({ email })
      if (response) {
        dispatch(setMessage(response?.data?.message)) 
        
        //reset timer to 0
        handleReset()

        //start timer
        handleStart()

        dispatch(setAppLoading(false))
      }
    } catch (error) {
      console.log('err', error)
      dispatch(setAppLoading(false))
    }
  }

  const handleChange = (data) => {
    if (data.otp && !requestCompleted) {
      setValue(data.otp)
    }
  }


  const validateRoute = () => {
    const user = JSON.parse(localStorage.getItem('tempUser'))
    //validate user only if coming from forgot password or signup flow
    if (!user || user?.type !== 1 && user?.type !== 2) {
      navigate('/login')
      return
    }
  }

  // const handlePromptResponse = (response) => {
  //   // const location = JSON.parse(JSON.stringify(blocker));
  //   setShowPrompt(prev => !prev)

  //   if (!response) setNavigationRoute('')
  //   else {
  //     setValue(null)
  //     // setNavigationRoute(location.location.pathname)
  //   }

  //   // blocker.reset()
  // }

  const handleSubmit = async (values) => {
    try {
      if (!values || !Object.keys(values).length) {
        dispatch(setError("Please provide OTP"))
        return
      }
      let userData = JSON.parse(localStorage.getItem('tempUser'))
      if (!userData) return
      const { email } = userData

      dispatch(setAppLoading(true))

      const response = await verifyOtp({ email, code: values?.otp })
      // const response = true
      if (response) {
        setRequestCompleted(true)
        setValue(null)
        dispatch(setMessage(response?.data?.message))
        dispatch(setAppLoading(false))

        //handle signup otp
        if (userData.type === 1) {
          if (userData.roleId && userData.roleId === 2) setOpenBusinessActionModal(true)
          navigate('/login')
        }
        //handle forgot password otp
        else if (userData.type === 2) {
          userData.type = authTypes.indexOf('resetPassword')
          localStorage.setItem('tempUser', JSON.stringify(userData))
          navigate('/reset-password')
        }
        else {
          navigate('/login')
        }
      }
    } catch (error) {
      console.log(error)
      dispatch(setAppLoading(false))
    }

  };

  const submitForm = () => {
    document.querySelector('form')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
  }


  // useEffect(() => {
  //   if (navigationRoute) {
  //     if (blocker.state == 'unblocked') navigate(navigationRoute)
  //   }
  // }, [showPrompt])

  useEffect(() => {
    if(timeLeft == 0){
      handleStop()
    }
  }, [timeLeft])
  

  useEffect(() => {
    let timerInterval;
    if (isRunning) {
      timerInterval = setInterval(() => {
        dispatch(decrementTimer());
      }, 1000);
    }

    return () => {
      clearInterval(timerInterval);
    };
  }, [isRunning, dispatch]);


  useEffect(() => {
    validateRoute()

    //reset existing timers
    dispatch(resetTimer(60))
    handleStop()
  }, [])

  

  return (
    <AuthLayout>
      <Row className="flex justify-center otp-screen custom-card-boxshadow px-4 py-5 rounded-md">
        <Col xs={24} sm={18} md={18} className="form-section">
          <img src={logo} alt='logo' className="img-fluid logo mb-12" />
          <h4 className="heading-4 font-bold mb-4">Enter the 4 Digit Code</h4>
          <p className="text-slate-500 mb-8">A 4 digit code is sent to your email address</p>
          <DynamicForm onSubmit={handleSubmit} form={form} onChange={handleChange} />
          <div className="flex md:flex-row sm:flex-row flex-col justify-between items-center w-full mb-6 mt-2">
            <div className="flex items-center w-full justify-center md:mb-0 sm:mb-0 mb-2">
              <small className="text-slate-400">
                Didn't receive the code?
                <span 
                  className={`ml-1 font-bold text-black text-sm cursor-pointer 
                    ${ timeLeft >= 0 && isRunning && 'pointer-events-none text-gray-200'}`}
                  onClick={handleOtp}>Resend
                </span>
                { timeLeft >= 0 && isRunning && (
                  <div className="timer-display">
                    {`${Math.floor(timeLeft / 60)}:${(timeLeft % 60).toString().padStart(2, '0')}`}
                  </div>
                )}
              </small>
            </div>
            <Button.Basic
              onClick={submitForm}
              disabled={false}
              icon={null}
              loading={false}
              type="primary"
              size='medium'
              text='Verify'
              className='btn-primary md:w-fit sm:w-fit w-full'
            />
          </div>
          <div className="text-slate-300 dashed-line w-full mb-3"></div>
          <div className="mb-3 w-full flex justify-center">
            <div>
              <small className="text-slate-400">Already have an account?</small>
              <Link to='/login' className="ml-1 font-bold" >Login</Link>
            </div>
          </div>
        </Col>
        {/* <Modal.Basic open={openBusinessActionModal} onCancel={closeModal} width={400}>
          <div className="p-4">
            <BusinessActions />
          </div>
        </Modal.Basic> */}

        {/* <PageLeavePrompt state={!requestCompleted && blocker.state == 'blocked'} onChange={handlePromptResponse} /> */}
      </Row>
    </AuthLayout>
  );
};

export default Verification;



